import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Divider from 'material-ui/Divider';

const styles = () => ({
  sectionHead: {
    marginTop: '50px',
    padding: '0px 10px 20px 10px',
    fontWeight: 'bold',
  },
});

const SectionHead = props => {
  const { classes, style } = props;

  const renderTitle = () => {
    if (props.children) {
      return (
        <div className={classes.sectionHead}>
          {props.children}
        </div>
      );
    } else if (props.title) {
      return (
        <Typography
          className={classes.sectionHead}
          variant="subheading">
          {props.title}
        </Typography>
      );
    }
  }

  return (
    <div style={style}>
      {renderTitle()}
      <Divider className={classes.divider} />
    </div>
  );
}

SectionHead.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default withStyles(styles)(SectionHead);



// WEBPACK FOOTER //
// ./src/components/common/SectionHead.jsx